// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"106ccfa8","726":"f56a8af9"}[chunkId] + ".chunk.js";
};